import * as Yup from "yup";
import i18next from "i18next";

const phoneRegExp = /^[0-9]{10,15}$/;

export const UpdateProfileSchema = () => Yup.object({

    name: Yup.string().required(i18next.t('profile.error_name')),
    staffid: Yup.string().required(i18next.t('profile.error_staff_id')),
    mobile: Yup.string().matches(phoneRegExp, i18next.t('profile.error_invalid_mobile')).required(i18next.t('profile.error_mobile')),
    email: Yup.string().email(i18next.t('profile.error_email_invalid')).required(i18next.t('profile.error_email')),
    department: Yup.string().required(i18next.t('profile.error_department')),
    designation: Yup.string().required(i18next.t('profile.error_designation')),
    profile: Yup.mixed()
        .nullable()
        .test('fileType', i18next.t('profile.error_profile_photo_type'), (value) => {
            if (!value) return true; // File is optional
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            return allowedTypes.includes(value.type);
        })

});